import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRankedNFTsCollectionService } from "../../apiService/aIRanking";

interface RankedNFTsCollectionPayload {
  page: number;
  limit: number;
  score: number | string;
  network: string | number;
  popularity: number | string;
  price: number | string;
}

export const getRankedNFTsCollection = createAsyncThunk(
  "vyga/getRankedNFTsCollection",
  async (
    {
      page,
      limit,
      score,
      network,
      popularity,
      price,
    }: RankedNFTsCollectionPayload,
    { rejectWithValue }
  ) => {
    try {
      const result = await getRankedNFTsCollectionService(
        page,
        limit,
        score,
        network,
        popularity,
        price
      );
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
